import clsx from 'clsx'
import { formatOptions } from 'components/utility/autosuggest'
import { Portal } from 'components/utility/portal'
import React, { createContext, useCallback, useContext, useEffect, useId, useMemo, useRef, useState } from 'react'

const valueSelect = (value) => {
  if (typeof value === 'string') return value
  return value?.component
}

const SelectField = ({ required, options, selectedOption, placeholder, onSelect, label }) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)
  const id = useId()

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [dropdownRef])

  const handleToggle = () => {
    setIsOpen(!isOpen)
  }

  const handleSelectOption = (option) => {
    onSelect(option)
    setIsOpen(false)
  }

  const formattedOptions = useMemo(() => formatOptions(options), [options])

  return (
    <div className="select-field-container" ref={dropdownRef}>
      <div className="dome-d-flex dome-justify-between">
        {label && (
          <label htmlFor={id} className="dome-p3 dome-color-med-grey">
            {label}
          </label>
        )}
        {required && (
          <div className="dome-d-flex dome-align-center dome-gap3">
            <i className="fa-light fa-circle-exclamation dome-color-red-alert"></i>
            <span className="dome-p3 dome-color-red-alert">required</span>
          </div>
        )}
      </div>
      <button
        id={id}
        type="button"
        className="select-field-button"
        onClick={handleToggle}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        aria-controls="dropdown-options"
      >
        <span className="dome-p2 dome-color-darkest-grey">{valueSelect(selectedOption) ?? placeholder}</span>
        <i className="fa-solid fa-chevron-down dome-color-med-grey"></i>
      </button>
      {isOpen && (
        <div className="select-field-dropdown">
          <ul id="dropdown-options" role="listbox" style={{ margin: 0, padding: 0, listStyle: 'none' }}>
            {formattedOptions.map((option, index) => {
              return (
                <li
                  key={option.id}
                  role="option"
                  className="dome-p2 dome-color-dark-grey select-field-dropdown-item"
                  aria-selected={selectedOption?.value === option?.value}
                  onClick={() => handleSelectOption(option)}
                >
                  {option.component}
                </li>
              )
            })}
          </ul>
        </div>
      )}
    </div>
  )
}

export default SelectField
